module.exports = __webpack_public_path__ + "static/media/TN-Women-Pants-v2.0_OptionAll.86a64388.svg";